import { useMemo, useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
// import PDFActivity from 'elem/compCommon/PillarPageActivities/PDFActivity';
import AMZMemberDay from 'elem/compCommon/PillarPageActivities/AMZMemberDay';
// import MemberDrainageBar from '@elem/compCommon/MemberDrainageBar';
import A from './components/A';
import A1 from './components/A1';
import FixTab from './components/FixTab';
import css from './index.module.scss';
import EfScrollAni from '@/efscrollani';
import HeaderUserTipsH5 from '@/app/eflayout/HeaderCommon/HeaderUser/HeaderUserNone/HeaderUserTipsWin/HeaderUserTipsH5';
import { useRouter } from 'next/router';
import { getEfDeviceId } from 'lowcode/utils/getBrowserIdFromCanvas';
import { checkIsFirstVisitToday, recordTodayVisit, checkIsWithinTime, clearExpiredRecord } from '@/app/eflayout/Header/time';
import getDevice from 'lowcode/common/getDevice';
import { useSectionReveal } from './useSectionReveal';

const IndexDynamic = dynamic(() => import('./indexdynamic'), { ssr: true });

export default function OutdoorRecreation() {
    const { locale = 'us', pathname } = useRouter();
    const [showHeaderTips, setShowHeaderTips] = useState(true);
    const europeRegion = ['de', 'uk', 'eu', 'fr', 'es', 'it', 'nl'];
    useSectionReveal();

    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }

    const isSpecifySite = useMemo(() => {
        if (locale === 'us') {
            return ['/delta-pro-3-portable-power-station', '/power-preparedness'].includes(pathname);
        }
        if (locale === 'de') {
            return ['/vanlife-roadtrips', '/recreational-activities'].includes(pathname);
        }
        return false;
    }, [pathname, locale]);

    useEffect(() => {
        const deviceType = getDevice();

        if (!(deviceType === 'pad' || deviceType === 'h5')) {
            return;
        }

        const checkDailyFirstVisit = async () => {
            if (!isSpecifySite) return;

            try {
                const deviceId = await getEfDeviceId();
                if (!deviceId) return;

                // 生成页面唯一标识
                const pageKey = `${locale}${pathname}`;

                // 检查是否为今日首次访问
                const isFirstVisit = checkIsFirstVisitToday(deviceId, pageKey);
                if (isFirstVisit) {
                    // 记录今日访问
                    recordTodayVisit(deviceId, pageKey);
                    setShowHeaderTips(true);

                    // 10秒后自动关闭
                    setTimeout(() => {
                        setShowHeaderTips(false);
                    }, 5 * 1000);
                } else {
                    setShowHeaderTips(false);
                }
            } catch (error) {
                console.error('检查每日首次访问失败:', error);
            }
        };
        checkDailyFirstVisit();
    }, [isSpecifySite, locale, pathname]);

    useEffect(() => {
        const isFlag = checkIsWithinTime(locale);
        if (isFlag) {
            return;
        }
        clearExpiredRecord();
        setShowHeaderTips(true);
        setTimeout(() => {
            setShowHeaderTips(false);
        }, 5 * 1000);
    }, []);

    return (
        <div className={`outdoor-recreation ${css['outdoor-recreation']}`}>
            {isSpecifySite && showHeaderTips && <HeaderUserTipsH5 />}
            {europeRegion.includes(locale) ? <A1 /> : <A />}
            <AMZMemberDay />
            {europeRegion.includes(locale) || locale === 'au' ? null : <FixTab />}
            <IndexDynamic />
            <style jsx global>
                {`
                    .ecoflow-header {
                        max-width: 100%;
                    }
                    .footer {
                        max-width: 100%;
                        overflow: hidden;
                    }
                `}
            </style>
        </div>
    );
}
